import { axiosInstance } from '../Axios';
const { createSlice } = require('@reduxjs/toolkit');

const getAxiosConfig = (token) => ({
	headers: {
		'Content-Type': 'application/json',
		Accept: 'application/json',
		Authorization: `Bearer ${token}`,
	},
});

const getErrorMessage = (error) =>
	error.response && error.response.data.message
		? error.response.data.message
		: error.message;

const DashBoardReducer = createSlice({
	name: 'dash',
	initialState: {
		success: false,
		error: null,
		leadStatusloading: false,
		leadCategoryloading: false,
		dashCountloading: false,
		followuploading: false,
		dashDocumentloading: false,
		dashFileSizeloading: false,
		dashboardloading: false,
		materialPendingLoading: false,

		leadStatusData: null,
		leadCategoryData: null,
		dashCountData: null,
		followupData: null,


		dashDocumentData: null,
		dashFileSizeData: null,
		dashboardData: null,
		materialPendingData: [],

	},
	reducers: {

		leadStatusRequest(state, action) {
			state.leadStatusloading = true;
		},
		leadStatusSuccess(state, action) {
			state.leadStatusloading = false;
			state.leadStatusData = action.payload;
			state.error = null;
		},
		leadStatusFail(state, action) {
			state.leadStatusloading = false;
			state.error = action.payload;
		},

		leadCategoryRequest(state, action) {
			state.leadCategoryloading = true;
		},
		leadCategorySuccess(state, action) {
			state.leadCategoryloading = false;
			state.leadCategoryData = action.payload;
			state.error = null;
		},
		leadCategoryFail(state, action) {
			state.leadCategoryloading = false;
			state.error = action.payload;
		},

		dashCountRequest(state, action) {
			state.dashCountloading = true;
		},
		dashCountSuccess(state, action) {
			state.dashCountloading = false;
			state.dashCountData = action.payload;
			state.error = null;
		},
		dashCountFail(state, action) {
			state.dashCountloading = false;
			state.error = action.payload;
		},

		followupRequest(state, action) {
			state.followuploading = true;
		},
		followupSuccess(state, action) {
			state.followuploading = false;
			state.followupData = action.payload;
			state.error = null;
		},
		followupFail(state, action) {
			state.followuploading = false;
			state.error = action.payload;
		},



		dashDocumentRequest(state, action) {
			state.dashDocumentloading = true;
		},
		dashDocumentSuccess(state, action) {
			state.dashDocumentloading = false;
			state.dashDocumentData = action.payload;
			state.error = null;
		},
		dashDocumentFail(state, action) {
			state.dashDocumentloading = false;
			state.error = action.payload;
		},

		dashFileSizeRequest(state, action) {
			state.dashFileSizeloading = true;
		},
		dashFileSizeSuccess(state, action) {
			state.dashFileSizeloading = false;
			state.dashFileSizeData = action.payload;
			state.error = null;
		},
		dashFileSizeFail(state, action) {
			state.dashFileSizeloading = false;
			state.error = action.payload;
		},
		// dashboard



		dashboardRequest(state, action) {
			state.dashboardloading = true;
		},
		dashboardSuccess(state, action) {
			state.dashboardloading = false;
			state.dashboardData = action.payload;
			state.error = null;
		},
		dashboardFail(state, action) {
			state.dashboardloading = false;
			state.error = action.payload;
		},
		materialPendingRequest(state) {
			state.materialPendingLoading = true;
		},
		materialPendingSuccess(state, action) {
			state.materialPendingLoading = false;
			state.materialPendingData = action.payload;
		},
		materialPendingFail(state, action) {
			state.materialPendingLoading = false;
			state.error = action.payload;
		}
	},
});

const { actions } = DashBoardReducer;
export const {

	leadStatusRequest,
	leadStatusSuccess,
	leadStatusFail,

	leadCategoryRequest,
	leadCategorySuccess,
	leadCategoryFail,

	dashCountRequest,
	dashCountSuccess,
	dashCountFail,

	followupRequest,
	followupSuccess,
	followupFail,

	dashDocumentRequest,
	dashDocumentSuccess,
	dashDocumentFail,

	dashFileSizeRequest,
	dashFileSizeSuccess,
	dashFileSizeFail,

	dashboardRequest,
	dashboardSuccess,
	dashboardFail,
	materialPendingRequest,
	materialPendingSuccess,
	materialPendingFail

} = actions;

export const dashLeadStatusDispatch = (bodyData, token) => async (dispatch) => {
	try {
		const config = {
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: `Bearer ${token}`,
			},
		};
		dispatch(leadStatusRequest());
		const { data } = await axiosInstance.post(
			'/dashboard/stagecountlist',
			bodyData,
			config
		);
		dispatch(leadStatusSuccess(data));

	} catch (error) {
		dispatch(
			leadStatusFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};
export const dashCategoryCountDispatch = (bodyData, token) => async (dispatch) => {
	try {
		const config = {
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: `Bearer ${token}`,
			},
		};
		dispatch(leadCategoryRequest());
		const { data } = await axiosInstance.post(
			'/dashboard/categoryCountList',
			bodyData,
			config
		);
		dispatch(leadCategorySuccess(data));

	} catch (error) {
		dispatch(
			leadCategoryFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};
export const dashCountDispatch = (bodyData, token) => async (dispatch) => {
	try {
		const config = {
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: `Bearer ${token}`,
			},
		};
		dispatch(dashCountRequest());
		const { data } = await axiosInstance.post(
			'/dashboard/dashboarddata',
			bodyData,
			config
		);
		dispatch(dashCountSuccess(data));

	} catch (error) {
		dispatch(
			dashCountFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};
export const dashfollowupDispatch = (bodyData, token) => async (dispatch) => {
	try {
		const config = {
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: `Bearer ${token}`,
			},
		};
		dispatch(followupRequest());
		const { data } = await axiosInstance.post(
			'/tasksub/followuplist',
			bodyData,
			config
		);
		dispatch(followupSuccess(data));

	} catch (error) {
		dispatch(
			followupFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};




export const dashDocumentDispatch = (form, token) => async (dispatch) => {
	try {
		dispatch(dashDocumentRequest());
		const { data } = await axiosInstance.get(
			'/FileUpload/GetDashboardFileList',
			getAxiosConfig(token)
		);

		dispatch(dashDocumentSuccess(data));
	} catch (error) {

		dispatch(dashDocumentFail(getErrorMessage(error)));
	}
};

export const dashSizeUsageDispatch = (token) => async (dispatch) => {
	try {
		dispatch(dashDocumentRequest());
		const { data } = await axiosInstance.get(
			'/Dashboard/GetFileSize',
			getAxiosConfig(token)
		);

		dispatch(dashFileSizeSuccess(data));
	} catch (error) {

		dispatch(dashFileSizeFail(getErrorMessage(error)));
	}
};


export const dashboardDispatch = (form, token) => async (dispatch) => {
	try {
		dispatch(dashboardRequest());
		const { data } = await axiosInstance.get(
			'/Dashboard/GetDashboard',
			getAxiosConfig(token)
		);

		dispatch(dashboardSuccess(data));
	} catch (error) {

		dispatch(dashboardFail(getErrorMessage(error)));
	}
};

export const getMaterialPendingListDispatch = (form, token) => async (dispatch) => {
	try {
		dispatch(materialPendingRequest());
		const { data } = await axiosInstance.get('/Dashboard/GetMaterialPendingList', {
			...getAxiosConfig(token),
			params: {
				ProjectId: form?.ProjectId ?? form?.projectId ?? 0,
				MaterialId: form?.MaterialId ?? form?.materialId ?? 0,
			},
		});
		dispatch(materialPendingSuccess(Array.isArray(data) ? data : data?.data || []));
		return data;
	} catch (error) {
		dispatch(materialPendingFail(getErrorMessage(error)));
		return { status: 0, message: getErrorMessage(error) };
	}
};

export default DashBoardReducer;
